import { Snackbar, Alert } from "@mui/material";
import Button from "../Button/Button";

const AppSnackbar = ({
  open = false,
  type = "info", // success | error | warning | info
  message = "",
  autoHideDuration = 2000,
  anchorOrigin = { vertical: "top", horizontal: "center" },
  showAction = false,
  actionText = "OK",
  onClose,
  onAction,
}) => {
  // const handleClose = (_, reason) => {
  //   if (reason === "clickaway") return;
  //   onClose?.();
  // };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    onClose?.(event, reason);
  }

  if((type==="error" || type==="warning") && autoHideDuration <= 2000){
    autoHideDuration = 4000
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      sx={{
        zIndex: 2400,
      }}
    >
      <Alert
        onClose={handleClose}
        severity={type}
        variant="filled"
        sx={{
          width: "100%",
          alignItems: "center",
        }}
        action={
          showAction ? (
            <Button
              variant="primary"
              size="small"
              sx={{ minWidth: 70, textTransform: "none" }}
              // onClick={() => {
              //   onAction?.();
              //   onClose?.();
              // }}
              onClick={(event) => {
                onAction?.();
                onClose?.(event, "action");
              }}
            >
              {actionText}
            </Button>
          ) : null
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbar;
